import { ResolvedSentryConfigurationInterface, ResolveSentryConfigurationOptionsInterface } from './sentryConfig.types'

const placeholderEnvironmentPattern = /^\$\{.+\}$/

const normalizeSentryDsn = (value: string | undefined): string | undefined => {
  if (value === undefined) {
    return undefined
  }

  const normalizedValue = value.trim()

  if (normalizedValue === '' || placeholderEnvironmentPattern.test(normalizedValue)) {
    return undefined
  }

  return normalizedValue
}

export const resolveSentryConfiguration = ({
  fallbackDsn,
  isDevelopment,
  runtimeDsn,
}: ResolveSentryConfigurationOptionsInterface): ResolvedSentryConfigurationInterface => {
  const explicitRuntimeDsn = normalizeSentryDsn(runtimeDsn)
  const dsn = explicitRuntimeDsn ?? normalizeSentryDsn(fallbackDsn)

  return {
    dsn,
    enabled: isDevelopment ? explicitRuntimeDsn !== undefined : dsn !== undefined,
  }
}
